export function createWhiteNoise(audioContext) {
  const bufferSize = 2 * audioContext.sampleRate;

  const bufferLeft = audioContext.createBuffer(
    1,
    bufferSize,
    audioContext.sampleRate
  );
  const dataLeft = bufferLeft.getChannelData(0);

  const bufferRight = audioContext.createBuffer(
    1,
    bufferSize,
    audioContext.sampleRate
  );
  const dataRight = bufferRight.getChannelData(0);

  for (let i = 0; i < bufferSize; i++) {
    dataLeft[i] = Math.random() * 2 - 1;
    dataRight[i] = Math.random() * 2 - 1;
  }

  const stereoBuffer = audioContext.createBuffer(
    2,
    bufferSize,
    audioContext.sampleRate
  );

  stereoBuffer.copyToChannel(dataLeft, 0);
  stereoBuffer.copyToChannel(dataRight, 1);

  return stereoBuffer;
}
